import {
  LogicOptions,
  ModalTimeFrames,
  PlacementUrl,
  SelectorLocation,
  URLOptions,
} from './placement-types';

export const urlSelectOptions = [
  {
    label: 'URL contains',
    type: URLOptions.CONTAINS,
    not: false,
  },
  {
    label: 'URL does not contain',
    type: URLOptions.CONTAINS,
    not: true,
  },
  {
    label: 'URL starts with',
    type: URLOptions.STARTS,
    not: false,
  },
  {
    label: 'URL ends with',
    type: URLOptions.ENDS,
    not: false,
  },
  {
    label: 'URL exactly matches',
    type: URLOptions.EXACTLY,
    not: false,
  },
  {
    label: 'Wildcard',
    type: URLOptions.REGEX,
    not: false,
  },
];

export const defaultUrl: PlacementUrl = {
  operation: { type: URLOptions.CONTAINS, operand: '' },
  not: false,
};

export enum PageOptions {
  MULTI_PAGE = 'multi_page',
  EVERYWHERE = 'everywhere',
}

export const PAGE_OPTIONS_TXT = {
  [PageOptions.MULTI_PAGE]: 'On specific page/s',
  [PageOptions.EVERYWHERE]: 'On all pages',
};

export const LOGIC_OPTIONS_TXT = {
  [LogicOptions.ALL]: 'Match all',
  [LogicOptions.ANY]: 'Match any',
};

export const MODAL_TIME_FRAMES_TXT = {
  [ModalTimeFrames.UNTIL_DISMISSED]: 'Only once',
  [ModalTimeFrames.FOREVER]: 'On every page load',
};

export const positioningOptions = [
  {
    label: 'Above content',
    value: SelectorLocation.START,
  },
  {
    label: 'Below content',
    value: SelectorLocation.END,
  },
  {
    label: 'Replace content',
    value: SelectorLocation.REPLACE,
  },
];

export type PageOptionItem = {
  label: string;
  value: PageOptions;
};

export type LogicOptionItem = {
  label: string;
  value: LogicOptions;
};

export const logicOptions: LogicOptionItem[] = [
  {
    label: LOGIC_OPTIONS_TXT[LogicOptions.ALL],
    value: LogicOptions.ALL,
  },
  {
    label: LOGIC_OPTIONS_TXT[LogicOptions.ANY],
    value: LogicOptions.ANY,
  },
];

export const pageOptions: PageOptionItem[] = [
  {
    label: PAGE_OPTIONS_TXT[PageOptions.EVERYWHERE],
    value: PageOptions.EVERYWHERE,
  },
  {
    label: PAGE_OPTIONS_TXT[PageOptions.MULTI_PAGE],
    value: PageOptions.MULTI_PAGE,
  },
];

export const showUntilOptions = [
  {
    label: 'On every page load',
    value: ModalTimeFrames.FOREVER,
  },
  {
    label: 'Until dismissed',
    value: ModalTimeFrames.UNTIL_DISMISSED,
  },
];

export const triggerModalOptions = [
  {
    label: 'On page load',
    value: ModalTimeFrames.FOREVER,
  },
];
